(() => {
  'use strict';
  const room = document.querySelector('[data-cowboy-room]');
  if (!room) return;
  const $ = s => room.querySelector(s);
  const $$ = s => [...room.querySelectorAll(s)];
  const labels = JSON.parse(document.querySelector('#cowboy-labels').textContent);
  const slots = ['shirts', 'jeans', 'boots'];
  const products = new Map();
  document.querySelectorAll('[data-cowboy-product]').forEach(el => {
    try { const p=JSON.parse(el.textContent); products.set(el.dataset.cowboyProduct,p); } catch {}
  });
  const requestedPieces = new URLSearchParams(location.search).get('pieces');
  const occasionHandles = requestedPieces && requestedPieces.length < 600 ? requestedPieces.split(',') : [];
  const occasionKeys = occasionHandles.length === 3 ? slots.map((slot,i)=>[...products].find(([key,p])=>key.startsWith(slot+'-') && p.handle===occasionHandles[i] && p.available)?.[0]) : [];
  const validOccasion = occasionKeys.length===3 && occasionKeys.every(Boolean);
  const keys = slot => [...products].filter(([key,p])=>key.startsWith(slot+'-') && p.available).map(([key])=>key);
  const selected = Object.fromEntries(slots.map(slot => [slot, keys(slot)[0] || slot+'-0']));
  const variants = Object.fromEntries(slots.map(slot => [slot, '']));
  const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:document.body.dataset.currency || 'USD'}).format(n/100);
  const message = $('[data-cowboy-message]');
  const requests = Object.fromEntries(slots.map(slot => [slot, 0]));
  const loaded = new Map();
  let applying = false;
  function ensureImage(image) {
    if (image.complete && !image.naturalWidth) return Promise.reject(new Error(labels.error));
    if (!loaded.has(image.src)) loaded.set(image.src, new Promise((resolve, reject) => {
      if (image.complete && image.naturalWidth) return resolve();
      image.addEventListener('load', resolve, {once:true});
      image.addEventListener('error', () => { loaded.delete(image.src); reject(new Error(labels.error)); }, {once:true});
    }));
    return loaded.get(image.src);
  }
  function selectTab(slot, focus=false) {
    $('[data-cowboy-stage]').dataset.zoomSlot=slot;
    $$('[data-cowboy-tab]').forEach(tab => {
      const active = tab.dataset.cowboyTab === slot;
      tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
      document.getElementById('cowboy-panel-' + tab.dataset.cowboyTab).hidden = !active;
      if (active && focus) tab.focus();
    });
  }
  function sync() {
    let total=0;
    for (const slot of slots) {
      const p=products.get(selected[slot]);
      const variant=p?.variants.find(v=>String(v.id)===String(variants[slot]));
      total+=variant?.price ?? p?.price ?? 0;
      $$('[data-cowboy-wear]').filter(b=>b.dataset.cowboyWear.startsWith(slot+'-')).forEach(b=>{
        const on=b.dataset.cowboyWear===selected[slot];
        b.setAttribute('aria-pressed',String(on));
        b.querySelector('.cowboy-wear-label').textContent=on?labels.wearing+' ✓':labels.try+' ↗';
      });
    }
    const photos=$('[data-cowboy-selected-photos]');
    photos.replaceChildren(...slots.map(slot=>{
      const p=products.get(selected[slot]), link=document.createElement('a'), img=document.createElement('img');
      if(!p)return link;
      const v=p.variants.find(v=>String(v.id)===String(variants[slot]));
      link.href='/products/'+p.handle;link.target='_blank';link.rel='noopener';link.title=p.title;
      img.src=v?.featured_image?.src || p.featured_image;img.alt=p.title;img.width=120;img.height=120;
      link.append(img);return link;
    }));
    $('[data-cowboy-total]').textContent=money(total);
    $('[data-cowboy-apply]').disabled=applying;
    $('[data-cowboy-stage]').setAttribute('aria-label', labels.label + ': ' + slots.map(slot=>products.get(selected[slot])?.title || labels.empty).join(', '));
  }
  function sizeOptions(slot) {
    const select=$('[data-cowboy-size="'+slot+'"]');
    const p=products.get(selected[slot]);
    select.replaceChildren(new Option(labels.choose_size, ''));
    for (const v of p?.variants || []) {
      const option=new Option(v.title+' — '+money(v.price)+(v.available?'':' — '+labels.unavailable),String(v.id));
      option.disabled=!v.available; select.append(option);
    }
    select.disabled=!p?.available;
    select.value=String(variants[slot] || '');
  }
  async function wear(key, preserveVariant='') {
    if (!key) return;
    const slot=key.split('-')[0];
    if (!slots.includes(slot) || !products.has(key)) return;
    const token=++requests[slot];
    const layer=$('[data-cowboy-key="'+key+'"]');
    const isBase=key===slot+'-0';
    message.textContent=labels.loading;
    try {
      if (!isBase && !layer) throw new Error(labels.error);
      if (layer && !isBase) {
        if (layer.dataset.cowboySrc && !layer.getAttribute('src')) layer.src=layer.dataset.cowboySrc;
        await ensureImage(layer);
      }
      if (token!==requests[slot]) return;
      $$('[data-cowboy-layer="'+slot+'"]').forEach(image=>{image.hidden=image!==layer || isBase;});
      selected[slot]=key;variants[slot]=preserveVariant;
      sizeOptions(slot);sync();
      message.textContent=labels.wearing+': '+products.get(key).title;
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) $('[data-cowboy-stage]').animate([{opacity:.84},{opacity:1}],{duration:220});
    } catch(e) { if(token===requests[slot]) message.textContent=e.message; }
  }
  room.addEventListener('click',async e=>{
    const b=e.target.closest('button');if(!b)return;
    if(b.dataset.cowboyTab){selectTab(b.dataset.cowboyTab);return;}
    if(b.dataset.cowboyWear){await wear(b.dataset.cowboyWear);return;}
    if(b.hasAttribute('data-cowboy-reset')){await Promise.all(slots.map(slot=>wear(slot+'-0')));return;}
    if(b.hasAttribute('data-cowboy-random')){
      const next=Object.fromEntries(slots.map(slot=>[slot,keys(slot)[Math.floor(Math.random()*keys(slot).length)]]));
      if(slots.every(slot=>next[slot]===selected[slot]))next.shirts='shirts-'+(selected.shirts.endsWith('0')?'1':'0');
      await Promise.all(slots.map(slot=>wear(next[slot])));return;
    }
    if(b.hasAttribute('data-cowboy-zoom')){
      const on=$('[data-cowboy-stage]').classList.toggle('is-zoomed');b.setAttribute('aria-pressed',String(on));b.textContent=on?labels.zoom_out+' −':labels.zoom+' +';return;
    }
    if(b.hasAttribute('data-cowboy-apply')){
      const missing=slots.find(slot=>!variants[slot] || !products.get(selected[slot])?.variants.some(v=>String(v.id)===String(variants[slot])&&v.available));
      if(missing){message.textContent=labels.choose_all;$('[data-cowboy-size="'+missing+'"]').focus();return;}
      applying=true;sync();message.textContent=labels.applying;
      document.dispatchEvent(new CustomEvent('veloura:apply-outfit',{detail:{
        items:slots.map(slot=>({handle:products.get(selected[slot]).handle,id:variants[slot]})),
        replaceHandles:[...products.values()].map(p=>p.handle),
        done:(error)=>{applying=false;sync();message.textContent=error||labels.ready;if(!error)document.getElementById('your-look').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
      }}));
    }
  });
  $$('[data-cowboy-size]').forEach(select=>select.addEventListener('change',()=>{variants[select.dataset.cowboySize]=select.value;sync();message.textContent='';}));
  $$('[data-cowboy-tab]').forEach(tab=>tab.addEventListener('keydown',e=>{
    const i=slots.indexOf(tab.dataset.cowboyTab);let next;
    if(e.key==='ArrowRight')next=(i+1)%slots.length;
    if(e.key==='ArrowLeft')next=(i+slots.length-1)%slots.length;
    if(e.key==='Home')next=0;if(e.key==='End')next=slots.length-1;
    if(next!==undefined){e.preventDefault();selectTab(slots[next],true);}
  }));
  document.addEventListener('veloura:look-restored',async e=>{
    if(requestedPieces)return;
    for(const item of e.detail || []){
      const entry=[...products].find(([,p])=>p.handle===item.handle);
      if(entry && entry[1].variants.some(v=>String(v.id)===String(item.id)))await wear(entry[0],String(item.id));
    }
  });
  for(const slot of slots) {
    sizeOptions(slot);
    const tab=$('[data-cowboy-tab="'+slot+'"]');
    tab.textContent=labels[slot]+' ('+keys(slot).length+')';
  }
  sync();
  const preset=new URLSearchParams(location.search).get('outfit');
  if(validOccasion)Promise.all(occasionKeys.map(key=>wear(key)));
  else if(requestedPieces)message.textContent=labels.unavailable+' — '+labels.catalog;
  else if(/^[0-3][01][01]$/.test(preset || ''))Promise.all(slots.map((slot,i)=>wear(slot+'-'+preset[i])));
})();

